import { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import "../styles/SignUp.css"

import UserService from "../services/UserService";

function SignUp() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [password2Error, setPassword2Error] = useState("");
	
	const navigate = useNavigate();
	
	const signup = (e) => {
		e.preventDefault();
		setEmailError("");
		setPasswordError("");
		setPassword2Error("");
		
		if (!email.trim()) {
			setEmailError("Debe ingresar un correo");
			return;
		}
		
		if (!password.trim()) {
			setPasswordError("Debe ingresar un constraseña");
			return;
		}

		if (!password2.trim()) {
			setPassword2Error("Debe repetir la constraseña");
			return;
		}

		if (password.trim() !== password2.trim()) {
			setPassword2Error("Debe repetir la misma constraseña");
			return;
		}
		
		const user =  { email, password }
		UserService.signup(user)
		.then( (result) => { 				
			toast.success("Registro existoso!");
			navigate("/");
		})
		.catch( (e) => {
			toast.error(e.error);
		})
	}
	const back = () => {
		navigate("/");
	}
	const agree = () => {
		
	}
	return (
		<div className="Login vh-100 h-100 d-flex justify-content-center align-items-bottom">
			<Container fluid>
				<Row className="justify-content-center align-items-center vh-100 h-100">
					<Col xs={12} md={12} lg={6} className="bg-light p-4 text-center vh-100 h-100 border">
						<Row className="left">
							<Col className="col-1">
								<div className="m-2" onClick={back}>
									<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
										<path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
									</svg>
								</div>
							</Col>
							<Col className="center">
								<h5 className="mb-4">Registra tus datos</h5>
							</Col>
						</Row>

						<br />
						
						<Form>
							<div style={{marginTop: "4em"}}>
								<FloatingLabel controlId="floatingEmail" label="Correo" className="mb-4">
									<Form.Control type="email" placeholder="Correo" onChange={(e) => {setEmail(e.target.value)} } />
								</FloatingLabel>
								<p className="text-info position-absolute">{emailError}</p>
							</div>
							
							<div style={{marginTop: "4em"}}>
								<FloatingLabel controlId="floatingPassword" label="Contrase&ntilde;a" className="mb-4">
									<Form.Control type="password" placeholder="Contrase&ntilde;a" onChange={(e) => {setPassword(e.target.value)} }  />
								</FloatingLabel>
								<p className="text-info position-absolute">{passwordError}</p>
							</div>
							
							<div style={{marginTop: "4em"}}>
								<FloatingLabel controlId="floatingPassword2" label="Repetir Contrase&ntilde;a" className="mb-4">
									<Form.Control type="password" placeholder="Repetir Contrase&ntilde;a" onChange={(e) => {setPassword2(e.target.value)} }  />
								</FloatingLabel>
								<p className="text-info position-absolute">{password2Error}</p>
							</div>
							
							<div className="d-block" style={{marginTop: "4em"}}>
								<div className="d-block align-self-end">
									<div className="left mb-4 my-4">	
										<input type="checkbox" checked onChange={agree} /> Al continuar aceptas nuestros <b><a href="#">t&eacute;rminos y condiciones</a></b> as&iacute; como nuestra <b><a href="#">p&oacute;litica de privacidad</a></b>.
									</div>
									
									<Button variant="primary" type="submit" className="my-4 p-3 text-white col-12" onClick={signup}>
										CONTINUAR
									</Button>
								</div>
							</div>
							
						</Form>
						
					</Col>
				</Row>
			</Container>		
		</div>
	);
}

export default SignUp;
